// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"818b6e57","40":"446b82a4","409":"308c98f5","508":"53d37424","603":"671ef7f0","634":"ff730888","696":"37189f9c","898":"b1a2fcf8"}[chunkId] + ".chunk.js";
};